"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMainContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledMainContainer = styled_components_1.default.div `
  background: ${config_1.colors.sidewalk};
  padding: 20px 40px 20px;
  width: 100%;
  overflow: auto;
  margin-bottom: 20px;
`;
